import { useStores } from "@ms/planner-container-controls/lib/local/hooks/useStores";
import { ActionCreator, useActionCreators } from "@ms/planner-container-controls/lib/local/hooks/useActionCreators";
import { Store } from "@ms/planner-stores/lib/local/stores/Store";
import React, { Suspense, useEffect } from "react";
import { LazyLoopResponseSection } from "./LazyLoopResponseSection";
// Constants
import { CopilotWorkflowUnifiedState } from "@ms/uno-constants/lib/local/WorkflowConstants";
// Utilities
import { useLoggers } from "@ms/planner-presentational-controls/lib/local/utilities/hooks/useLoggers";
import { getPlanPermissionsFromStores } from "@ms/planner-stores/lib/local/utilities/PermissionsUtilities";
/**
 * The LoopResponseSectionContainer component
 * @param props - The props for the component
 */ export const LoopResponseSectionContainer = ({ fetchAccessTokenCallback, taskId })=>{
    const [taskStore, permissionsStore, planStore, appContextStore, modernGroupsStore, rosterStore, userStore, teamsChannelStore, driveItemStore, todoStore, viewStore, dependencyStore] = useStores([
        Store.Tasks,
        Store.Permissions,
        Store.Plan,
        Store.AppContext,
        Store.ModernGroups,
        Store.Roster,
        Store.User,
        Store.TeamsChannel,
        Store.DriveItem,
        Store.Todo,
        Store.View,
        Store.Dependency
    ]);
    const { traceLogger } = useLoggers();
    const [viewTransformsAc] = useActionCreators([
        ActionCreator.ViewTransforms
    ]);
    const task = taskStore.getTask(taskId)?.data;
    // Mark agent output as seen when this component mounts (i.e. the Agent tab becomes visible).
    // Mark agent output as seen when this component mounts (i.e. the Agent tab becomes visible).
    // All deps are included so the check re-runs if task state or store refs change.
    useEffect(()=>{
        if (task?.hasCompletedAgentOutput() && viewStore.hasUnseenAgentOutput(taskId)) {
            viewTransformsAc.setAgentOutputUnseen(taskId, false);
        }
    }, [
        task,
        taskId,
        viewStore,
        viewTransformsAc
    ]);
    if (!task) {
        return null;
    }
    const planId = task?.planId;
    const plan = planId ? planStore?.getPlan(planId)?.data : null;
    if (!plan) {
        return null;
    }
    const copilotErrorState = task.getCopilotWorkflowState() === CopilotWorkflowUnifiedState.Error;
    const loopPageUrl = taskStore?.getLoopPageUrlForTask(taskId).data ?? "";
    const isLoopURLLoading = taskStore?.getLoopPageUrlForTask(taskId).status.isFetching;
    const taskAssignedToCopilot = task.isAssignedToCopilotAgent();
    const planPermissions = getPlanPermissionsFromStores(plan, {
        permissionsStore,
        modernGroupsStore,
        rosterStore,
        userStore,
        teamsChannelStore,
        appContextStore,
        planStore,
        driveItemStore,
        todoStore,
        dependencyStore,
        taskStore
    }, traceLogger);
    // Only render if we have a loop URL and agent permissions
    if (!taskAssignedToCopilot && !isLoopURLLoading && !(loopPageUrl && planPermissions.canUseAgents) && !copilotErrorState) {
        return null;
    }
    return /*#__PURE__*/ React.createElement(Suspense, {
        fallback: /*#__PURE__*/ React.createElement(React.Fragment, null)
    }, /*#__PURE__*/ React.createElement(LazyLoopResponseSection, {
        fetchAccessTokenCallback: fetchAccessTokenCallback,
        loopPageUrl: loopPageUrl,
        taskId: taskId,
        isLoopURLLoading: isLoopURLLoading
    }));
};
LoopResponseSectionContainer.displayName = "LoopResponseSectionContainer";
